import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    pollInterval: { type: Number, default: 2000 },
    maxPolls: { type: Number, default: 30 },
    statusUrl: String,
    fallbackUrl: String
  }

  connect() {
    this.pollCount = 0
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.pollTimer = setInterval(() => {
      this.pollCount++

      if (this.pollCount > this.maxPollsValue) {
        this.stopPolling()
        this.showTimeoutMessage()
        return
      }

      this.checkStatus()
    }, this.pollIntervalValue)
  }

  async checkStatus() {
    try {
      const response = await fetch(this.statusUrlValue, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) return

      const data = await response.json()

      if (data.status === "completed" && data.redirect_url) {
        this.stopPolling()
        Turbo.visit(data.redirect_url)
      } else if (data.status === "failed") {
        this.stopPolling()
        Turbo.visit(this.fallbackUrlValue)
      }
    } catch (error) {
      // Silently fail and try again on next poll
    }
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }

  showTimeoutMessage() {
    const container = document.getElementById('detection_container')
    if (container) {
      container.innerHTML = `
        <div class="mb-6">
          <div class="inline-flex items-center justify-center w-24 h-24 bg-amber-100 rounded-full">
            <svg class="h-12 w-12 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
        </div>
        <h2 class="text-2xl font-bold text-gray-900 mb-4">Detection Taking Longer Than Expected</h2>
        <p class="text-gray-600 mb-6">No worries! You can draw your pool manually on the next screen.</p>
        <a href="${this.fallbackUrlValue}" class="btn btn-primary btn-lg">
          Continue to Draw Pool
        </a>
      `
    }
  }
}
